/**
 * Helps TS narrow down the type of `obj` based on `condition`
 */
export const narrow = <TResult>(obj: any, condition: boolean): obj is TResult => condition;
